const StickyLandingView = () =>
  import(
    /*webpackChunkName: "StickyLanding"*/ "../../../views/sales/StickyLanding.vue"
  );
export default {
  path: "lp/content",
  name: "lp-content",
  alias: ["lp/contenido"],
  component: StickyLandingView,
  meta: { requiresAuth: false, requiresEntitlement: false },
};
